module.exports = __webpack_public_path__ + "img/foot-icon.13cc3a20.png";